import { render } from "./TailwindPlayground.vue?vue&type=template&id=4c6ec958"
import script from "./TailwindPlayground.vue?vue&type=script&lang=js"
export * from "./TailwindPlayground.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__